import { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import SafeAvatar from "@/components/SafeAvatar";

function timeAgo(iso) {
  if (!iso) return "";
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "à l'instant";
  if (m < 60) return `${m} min`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h`;
  return `${Math.round(h / 24)}j`;
}

export default function Messages({ role }) {
  const nav = useNavigate();
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/messages/threads").then((r) => { setThreads(r.data); setLoading(false); });
  }, []);

  return (
    <AppShell role={role} title="Messages">
      {loading && <div className="text-center py-10 text-slate2">Chargement…</div>}
      {!loading && threads.length === 0 && (
        <div className="bg-white rounded-2xl border border-border p-8 text-center">
          <div className="h-14 w-14 rounded-2xl bg-bone mx-auto flex items-center justify-center mb-3">
            <MessageCircle className="w-6 h-6 text-slate2" />
          </div>
          <h3 className="font-heading font-bold text-ink">Aucun message pour l'instant</h3>
          <p className="text-sm text-slate2 mt-1.5">
            {role === "pro"
              ? "Débloquez une demande pour démarrer une conversation."
              : "Vos pros vous répondront ici dès qu'ils auront débloqué votre demande."}
          </p>
        </div>
      )}
      <div className="space-y-2">
        {threads.map((t) => (
          <button
            key={t.lead_id + (t.partner?.id || "")}
            onClick={() => nav(`/thread/${t.lead_id}/${t.partner.id}`)}
            className="w-full flex items-center gap-3 bg-white border border-border rounded-2xl p-3 tap-scale text-left"
            data-testid={`thread-${t.lead_id}`}
          >
            <SafeAvatar src={t.partner?.avatar} role={t.partner?.role} name={t.partner?.name} className="w-12 h-12 rounded-xl object-cover" />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <div className="font-heading font-bold text-sm text-ink truncate">{t.partner?.name || "Utilisateur"}</div>
                <span className="text-[10px] text-slate2 shrink-0">{timeAgo(t.last_at)}</span>
              </div>
              <div className="text-xs text-slate2 truncate">{t.lead_title}</div>
              <div className="text-xs text-ink truncate mt-0.5">{t.last_body}</div>
            </div>
          </button>
        ))}
      </div>
    </AppShell>
  );
}
